(ns frontend.view.onboarding.terms-acceptance.db
  (:require [frontend.db :as db]
            [reagent.core :as r]))

(defonce tenant db/tenant)
(defonce session db/session)
(defonce role db/role)
(defonce account (r/cursor session [:account]))
(defonce account-terms-accepted (r/cursor account [:account/terms-accepted]))
(defonce state (r/cursor db/app-state [:views :accept-terms]))
